import { ChevronDownIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import React from 'react';

export interface ModalSelectVariantV2Props {
	open: boolean;
	variant: number | null;
	config: {
		key: string;
		value: any[];
	}[];
	onToggleDialog: () => void;
	onSelectVariant: (id: number) => void;
}

const ModalSelectVariantV2: React.FC<ModalSelectVariantV2Props> = ({
	variant,
	config,
	open,
	onToggleDialog,
	onSelectVariant,
}) => {
	return (
		<div className='w-full lg:w-fit relative'>
			<div
				onClick={() => {
					onToggleDialog();
				}}
				className='text-base hidden cursor-pointer group lg:block font-normal text-[#71717A]'
			>
				<div className='flex items-center gap-1 text-base text-[#71717A]'>
					<span className='whitespace-nowrap group-hover:text-primary'>Phân loại hàng:</span>
					<ChevronDownIcon width={20} className='group-hover:text-primary' />
				</div>
			</div>
			<div
				onClick={() => {
					onToggleDialog();
				}}
				className='flex lg:hidden cursor-pointer text-small justify-end font-normal text-[#71717A]'
			>
				<div
					className='flex items-center gap-1 text-small text-[#71717A]'
					onClick={() => {
						onToggleDialog();
					}}
				>
					<span className='whitespace-nowrap'>Phân loại hàng:</span>{' '}
					<div className='flex items-center gap-1'>
						<ChevronDownIcon width={14} />
					</div>
				</div>
			</div>
			<div
				className={classNames([
					'flex absolute top-[100%] z-[50] flex-col shadow-default gap-6 p-5 bg-base-100 rounded-box max-h-[345px] overflow-y-auto lg:w-[400px]',
					open ? 'block' : 'hidden',
				])}
			>
				{config.length > 0 &&
					config.map((item, index) => {
						return (
							<div key={index}>
								<div className='flex gap-8 mt-5 items-center'>
									<div className='text-base whitespace-nowrap'>{item.key}:</div>
									<div className='flex flex-wrap items-center w-full gap-2.5'>
										{item.value?.map((attr, i) => (
											<button
												type='button'
												className={classNames([
													'bg-[#ECEAEA] min-h-[32px] h-auto font-normal !text-left capitalize w-fit btn border-none hover:bg-primary hover:text-base-100 rounded-[16px] px-[12px] py-[6px] text-small text-primary',
													variant && variant === attr.variantId && '!bg-primary !text-base-100',
												])}
												key={i}
												onClick={() => {
													onSelectVariant(attr.variantId);
												}}
											>
												{attr.value}
											</button>
										))}
									</div>
								</div>
							</div>
						);
					})}

				{/* <div className='flex items-center gap-2'>
					<ButtonUI
						color='outline'
						text='Huỷ'
						htmlType='button'
						onClick={() => onActive?.(false)}
						className='text-center w-full'
					/>
					<ButtonUI
						color='primary'
						text='Xác nhận'
						htmlType='submit'
						className='text-center w-full'
					/>
				</div> */}
			</div>
		</div>
	);
};

export default ModalSelectVariantV2;
